<!--TODO个税计算器计算结果页面-->
<!--author zj-->
<template>
    <div class="Calculator" style="top: 0;position: absolute;">
        <detail-title></detail-title>
        <!-- <header-back heardback="CalculationResult"></header-back> -->
        <el-row class="Plan-heard" style="margin-top: 5rem;">
            <el-col :span="24" class="Plan-col">
                <img :src="bannerImg">
                <div class="Plan-intro" v-if="iscalc">
                <p class="intro-info">可帮你节税：<b>{{qnjs}}</b>（元）</p>
                </div>
            </el-col>
        </el-row>

        <el-row class="Plan-rbody" :class="{true:'pd',false:''}[iscalc]">
            <div class="Plan-col Plan-cb">
                <p class="Plan-title">最优方案</p>
                <div class="Plan-one">
                    <div class="clo-pip">
                        <div class="pie"></div>
                    </div>
                    <div class="clo-rt">
                        <dl>
                            <dt><i class="fa fa-circle lb"></i> 最优年终奖：{{result.nzj}}元</dt>
                            <dt><i class="fa fa-circle bb"></i> 最优全年薪资：{{result.qnxz}}元</dt>
                        </dl>
                    </div>
                </div>
                <div class="Plan-two">
                    <dl :class="{true:'ft-box',false:''}[!iscalc]">
                        <dt>年纳税总额：<b>{{result.nsze}}元</b></dt>
                        <dt>税后年收入：<b>{{result.nsr}}元</b></dt>
                    </dl>
                </div>
                <!-- 方案一 -->
                <div class="Plan-three" v-if="iscalc">
                    <div class="three-tit">
                        <img :src="ico" alt=""> 优化对比表</div>
                    <!-- <el-table :data="tableData" border style="width: 100%">
                        <el-table-column prop="lb" label="类别" width="100%"></el-table-column>
                        <el-table-column prop="yfa" label="原方案" width="100%"></el-table-column>
                        <el-table-column prop="yhfa" label="优化方案" width="100%"></el-table-column>
                    </el-table> -->
                    <table width="100%" class="gs-table">
                        <thead>
                            <th>类别</th>
                            <th>原方案</th>
                            <th class="th-bc">优化方案</th>
                        </thead>
                        <tbody>
                            <tr v-for="item in tableData" :key="item">
                            <td>{{item.lb}}</td>
                            <td>{{item.yfa}}</td>
                            <td class="th-yh">{{item.yhfa}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </el-row>
        <share-wechat></share-wechat>
    </div>
</template>
<script>
// import HeaderBack from "@/components/public/HeaderBack";
import { eventBus } from "@/assets/js/eventBus";
import ShareWechat from "@/components/ShareWechat";
import DetailTitle from '@/components/DetailTitle';
// import calc from '@/assets/js/auth.js';
export default {
    data(){
        return {
            list:[],
            bannerImg:require('@/assets/image/jsjg_bg.jpg'),
            ico:require('@/assets/image/VS_ico-01-01.svg'),
            bl:1,
            iscalc:true,
            qnjs:0,
            result:{
                nzj:0,
                qnxz:0,
                nsze:0,
                nsr:0
            },
            tableData:[{
                lb:"月工资",
                yfa: 0,
                yhfa:0
            },{
                lb:"年终奖",
                yfa:0,
                yhfa:0
            },{
                lb:"年纳税额",
                yfa:0,
                yhfa:0
            },{
                lb:"年收入总额",
                yfa:0,
                yhfa:0
            }]

        };
    },
    mounted(){
        const that = this;
        that.$route.query.obj==1?that.iscalc = true:that.iscalc = false;
        let list = that.$route.query;
        let porject = JSON.parse(list.data);
        that.qnjs = porject.qnjs;
        that.result.nzj = porject.nzj;
        that.result.qnxz = porject.qnxz;
        that.result.nsze = porject.nsze;
        that.result.nsr = porject.nsr;
        that.tableData[0].yfa = porject.yfa0;
        that.tableData[1].yfa = porject.yfa1;
        that.tableData[2].yfa = porject.yfa2;
        that.tableData[3].yfa = porject.yfa3;
        that.tableData[0].yhfa = porject.yhfa0;
        that.tableData[1].yhfa = porject.yhfa1;
        that.tableData[2].yhfa = porject.yhfa2;
        that.tableData[3].yhfa = porject.yhfa3;
        var shareList = {
            title: "个税筹划计算器上线了，快来测算吧！",
            content: "更多内容,请打开中税网通APP进行测算。"
        }
        eventBus.$emit("shareList",shareList);
    },
    components:{
        DetailTitle,
        ShareWechat
    },
};
</script>

<style lang="css">
   .ft-box{
       padding-bottom: 10rem !important;
   }
</style>
